import casesService from "api/casesService";
import listService from "api/listService";
import { ItemKind } from "dto/IKindItems";
import { ListType } from "dto/ListType";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function useFilterMetaData({
  listType,
  filterId,
  workspaceFilterId,
}: {
  listType: ListType;
  filterId?: string;
  workspaceFilterId?: string;
}) {
  const { t } = useTranslation();
  const [listId, setListId] = useState<number | null>(null);
  const [itemKinds, setItemKinds] = useState<number>(null);

  // Metadane filtra pobieramy tylko dla realnych filtrów (GUID). Wirtualne
  // identyfikatory (np. "as-received"/"as-cc" korzenia „Akceptacja i Podpis")
  // nie są zapisanymi filtrami — BE waliduje id jako GUID i zwróciłby 400.
  const isGuidFilter =
    !!filterId &&
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
      filterId,
    );

  const [listName, setListName] = useState("");
  const { data: metaData } = listService.useGetMetaData(filterId, isGuidFilter);
  const { data: caseFilter } = casesService.useGetFilter(
    workspaceFilterId,
    workspaceFilterId && listType === ListType.Cases
  );

  useEffect(() => {
    if (caseFilter) {
      setListName(caseFilter?.Name);
      setItemKinds(ItemKind.Cases);
    } else if (metaData && metaData.Id && metaData.Id !== "-1") {
      setListId(metaData?.List);
      setListName(metaData?.Name);
      setItemKinds(metaData?.ItemKinds);
    } else {
      setListId(10);
      setListName(t("common.all"));
      setItemKinds(ItemKind.All);
    }
  }, [metaData, caseFilter, t]);

  return {
    listId,
    listName,
    itemKinds,
  };
}
export default useFilterMetaData;
